import React, { useContext, useState, useEffect } from 'react';

import cookie from 'react-cookies';
import { useNavigate } from 'react-router';
import ClipLoader from 'react-spinners/ClipLoader';

import confetti from 'canvas-confetti';

import sandGlassImg from '../assets/images/bigSandGlass.png';
import PdfIcon from '../assets/images/pdf-icon.svg';
import Layout from '../components/common/Layout';
import TenantConfig from '../config';
import { doesApplicationHaveWIPSections, isApplicationWIP } from '../constants/status';
import { UserContext } from '../context/UserContext';
import { getApplicationId } from '../helpers/applicationHelp';
import { openFile } from '../helpers/file';
import { formatUSDCurrency } from '../helpers/format';

/** helpers */
import { getApplication } from '../service/api';

const MayQualify = () => {
  const navigate = useNavigate();
  const { appData, updateAppData, profile } = useContext(UserContext);
  const [redirectUrl, setRedirectUrl] = useState('/dashboard');
  const [offerProperty, setOfferProperty] = useState({});
  const timeout = 1000 * 5;

  useEffect(() => {
    if (isApplicationWIP(appData.status) || doesApplicationHaveWIPSections(appData)) {
      if (TenantConfig?.settings.useAddtionalDocPage !== true) {
        //for SBA etc. docs are requested as part of the application
        return setRedirectUrl(`/product/${appData.loanProductId}/application/${appData.id}`);
      } else {
        // for other they are requested on a specific documents page
        return setRedirectUrl('/additional-docs');
      }
    }
  }, [appData]);

  useEffect(() => {
    if (TenantConfig?.mayQualifiy?.showPreapprovedAmout === true) {
      setTimeout(() => {
        confetti({ particleCount: 180, spread: 150 });
      }, 750);
    }

    const timer = setInterval(async () => {
      const res = await getApplication();
      const lOfferProperty = res.data.applicationFeatures.find(
        (feature) => feature.itemType === 'OfferProperty'
      ).value;
      setOfferProperty(lOfferProperty);
      if (res && res.data) {
        updateAppData(res.data);
      }
    }, timeout);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async () => {
    return navigate('/dashboard');
  };

  const approvedProp = appData?.applicationFeatures?.find(
    (feature) => feature?.dataType === 'approvedrate'
  );

  const approvedLetterProp = appData?.applicationFeatures?.find(
    (feature) => feature?.itemType === 'ApprovalLetterProperty'
  );

  // approvedLetterProp?.value?.APP_FLAG_NAME = 'PREQUAL LETTER REQUEST';
  // approvedLetterProp?.value?.LOAN_PREQUAL_TYPE = 'PREQUAL LETTER';
  //we look if it is a multi/single approve rate
  const approvedRateValue =
    approvedProp?.value?.rates && approvedProp?.value?.rates.length > 0
      ? approvedProp?.value?.rates[0].approvedRate
      : approvedProp?.value;

  const mayQualScreenTypes = {
    BASIC_MAYQUAL: 'BASIC_MAYQUAL',
    PREQUAL_WITH_APPROVAL_LETTER: 'PREQUAL_WITH_APPROVAL_LETTER',
    LOAN_PRE_APPROVED: 'LOAN_PRE_APPROVED',
    LOAN_NOT_PRE_APPROVED: 'LOAN_NOT_PRE_APPROVED',
    MANUAL_REVIEW: 'MANUAL_REVIEW',
  };
  let mayQualTypeToShow;
  if (getTenant() === 'sba') {
    mayQualTypeToShow = mayQualScreenTypes.BASIC_MAYQUAL;
  } else if (appData.status == 'AUTOMATED_REVIEW_ADDITIONAL_DOCS_REQUIRED') {
    if (approvedRateValue.loanPreQualType == 'PREQUAL LETTER') {
      mayQualTypeToShow = mayQualScreenTypes.PREQUAL_WITH_APPROVAL_LETTER;
    } else if (approvedRateValue.loanPreQualType == 'PRE-APPROVED') {
      mayQualTypeToShow = mayQualScreenTypes.LOAN_PRE_APPROVED;
    } else {
      mayQualTypeToShow = mayQualScreenTypes.LOAN_NOT_PRE_APPROVED;
    }
  } else if (appData.status == 'MANUAL_REVIEW_REQUIRED_SALES') {
    mayQualTypeToShow = mayQualScreenTypes.MANUAL_REVIEW;
  }

  const downloadApprovalLetter = (approvedLetterProp) => {
    openFile(
      approvedLetterProp.value.fileId,
      approvedLetterProp.value.fileType,
      approvedLetterProp.value.fileType,
      true
    );
  };

  const renderMainContent = () => {
    if (mayQualTypeToShow === mayQualScreenTypes.PREQUAL_WITH_APPROVAL_LETTER) {
      return (
        <>
          <h2>
            Congrats! You are Pre-Qualified for a loan up to&nbsp;
            {TenantConfig?.mayQualifiy?.showPreapprovedAmout === true &&
              approvedRateValue?.approvedAmount && (
                <span style={{ fontSize: '65px', fontWeight: 'bold' }}>
                  {formatUSDCurrency(approvedRateValue?.approvedAmount)}
                </span>
              )}
            .
          </h2>
          {approvedLetterProp && (
            <>
              <div className="separator"></div>
              <h4>Pre-qualification letter</h4>
              <div>
                <a
                  href="#"
                  onClick={() => {
                    downloadApprovalLetter(approvedLetterProp);
                  }}
                >
                  <img src={PdfIcon} width="60px" alt="file" />
                  <div>View or Download</div>
                </a>
              </div>
            </>
          )}
          <div className="separator"></div>
          <h4>In order to proceed, we need to know more about you</h4>
          <p>{TenantConfig?.mayQualifiy.thankYou}</p>
        </>
      );
    }

    if (mayQualTypeToShow === mayQualScreenTypes.LOAN_NOT_PRE_APPROVED) {
      return (
        <>
          <h2>
            Thanks for submitting your application. You may qualify for a loan up to&nbsp;
            {TenantConfig?.mayQualifiy?.showPreapprovedAmout === true &&
              approvedRateValue?.approvedAmount && (
                <span style={{ fontSize: '65px', fontWeight: 'bold' }}>
                  {formatUSDCurrency(approvedRateValue?.approvedAmount)}
                </span>
              )}
            .
          </h2>
          <div className="separator"></div>
          <h4>In order to proceed, we need to know more about you</h4>
          <p>{TenantConfig?.mayQualifiy.thankYou}</p>
        </>
      );
    }

    if (mayQualTypeToShow === mayQualScreenTypes.LOAN_PRE_APPROVED) {
      return (
        <>
          <h2>
            Congrats! You are Pre-Approved for a loan up to&nbsp;
            {TenantConfig?.mayQualifiy?.showPreapprovedAmout === true &&
              approvedRateValue?.approvedAmount && (
                <span style={{ fontSize: '65px', fontWeight: 'bold' }}>
                  {formatUSDCurrency(approvedRateValue?.approvedAmount)}
                </span>
              )}
            .
          </h2>
          <div className="separator"></div>
          <h4>In order to proceed, we need to know more about you</h4>
          <p>{TenantConfig?.mayQualifiy.thankYou}</p>
        </>
      );
    }

    return (
      <>
        <h2>
          {/* You’re so close! Your business may qualify, but first we need to know more. */}
          {TenantConfig?.mayQualifiy?.docsPending}{' '}
          {TenantConfig?.mayQualifiy?.showPreapprovedAmout === true &&
            approvedRateValue?.approvedAmount && (
              <span style={{ fontSize: '65px', fontWeight: 'bold' }}>
                {formatUSDCurrency(approvedRateValue?.approvedAmount)}
              </span>
            )}
        </h2>
        <p>{TenantConfig?.mayQualifiy.thankYou}</p>
      </>
    );
  };

  const renderSecondContent = () => {
    return (
      <div className="need-docs">
        <div className="need-docs-header">
          <h1 className="title">We are looking it over</h1>
          {TenantConfig.isAmazonLayout() ? (
            <h3 className="subtitle">
              {profile.firstName}, thank you for submitting your application. <br />
              We are carefully reviewing your application. <br /> We appreciate your patience.
            </h3>
          ) : (
            <h3 className="subtitle">
              Thank you for submitting your application. <br />
              We are carefully reviewing your application. <br /> We appreciate your patience.
            </h3>
          )}
        </div>
        <div className="d-flex app-info">
          <div className="d-flex">
            <div className="app-number-text">
              <h3>Application Number: {getApplicationId(appData, false)}</h3>
              {TenantConfig?.reviewInProgress.renderAppNumberDescription &&
                offerProperty &&
                offerProperty.maxAmount && (
                  <p className="description">
                    {offerProperty.minApr === offerProperty.maxApr
                      ? offerProperty.minApr
                      : `${offerProperty.minApr} - ${offerProperty.maxApr}`}{' '}
                    % APR up to {formatUSDCurrency(offerProperty.maxAmount)} over{' '}
                    {offerProperty.loanTerm} months.
                  </p>
                )}
            </div>
          </div>
          <div className="status">
            <img src={sandGlassImg} alt="" />
            {TenantConfig?.reviewInProgress.showPendingText && <p>PENDING</p>}
          </div>
        </div>
        <div className={TenantConfig?.reviewInProgress.mainClassName}>
          <h1 className="title">What happens next?</h1>
          <h3 className="subtitle">{TenantConfig?.reviewInProgress?.subTitle}</h3>
        </div>
        {TenantConfig?.reviewInProgress.renderBelowSection && (
          <div className="need-docs-header">
            <h1 className="title">What Should You do?</h1>
            <h3 className="subtitle">
              Check your email for notification about your selection decision. You will be either
              selected, waitlisted, or not selected to move forward in the application process.
            </h3>
          </div>
        )}
        <div className="actions">
          <button className="primary-btn" onClick={handleSubmit}>
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  };

  return (
    <Layout>
      {appData ? (
        mayQualTypeToShow == mayQualScreenTypes.MANUAL_REVIEW ? (
          renderSecondContent()
        ) : (
          <div className="prequal-page">
            <div className="page-inner">
              <div>
                {redirectUrl === '/dashboard' ? (
                  <>
                    <h2>
                      Thank you for submitting your information, your application is being reviewed.
                    </h2>
                    <p>
                      You will receive an email from us if additional information is needed or what
                      your next steps are.
                      <br />
                      You may also check the status of the application at any time by logging on to
                      MyLendistry.
                      <br />
                      We look forward to helping your business!
                    </p>
                  </>
                ) : (
                  renderMainContent()
                )}
                <button
                  className="primary-btn"
                  onClick={() => {
                    navigate(redirectUrl);
                    cookie.save(`${appData.id}_may_qualify_visited`, 'visited', { path: '/' });
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )
      ) : (
        <div className="custom-spinner">
          <ClipLoader color="white" loading={loading} size={70} />
        </div>
      )}
    </Layout>
  );
};

export default MayQualify;
